import React, { Component } from "react";
import MapsTableRow from "./mapsTableRow";
import * as config from "../../data/config";
import Moment from "react-moment";

const MapsTable = ({ flightDetail, finalDate }) => {
  var moment = require("moment");
  let IsPaxBoarded = flightDetail.IsPaxBoarded;
  const getVisibility = (activity) => {
    // use boolean var to determine visible property
    return true;
  };

  const getColor = (statement, date) => {
    let timenow = moment();
    const isFlightDetailStatement = flightDetail[statement];

    if (!date.isValid()) {
      return "table-light";
    } else if (timenow <= date) {
      return isFlightDetailStatement ? "table-success" : "table-light";
    } else {
      return isFlightDetailStatement ? "table-success" : "table-danger";
    }
  };

  const getFlightActivities = () => {
    const { maps } = config.environment;
    const { fleetTypes, statements, times, checks } = maps;

    flightDetail.ModelOutbound = flightDetail.ModelOutbound || "DHC8-402"; //For QA and Dev Environment

    const model = Object.keys(fleetTypes).find(
      (key) => fleetTypes[key] === flightDetail.ModelOutbound
    );

    if (!times[model]) {
      return [];
    }

    const sortedActivities = Object.keys(times[model]).sort(
      (a, b) => times[model][b] - times[model][a]
    );

    return sortedActivities.map((activity) => {
      const date = moment(finalDate);
      const time = date.isValid()
        ? date.subtract(times[model][activity], "minutes").format("HH:mm")
        : "—:—"; // setting Default time for invalid date

      return {
        statement: statements[activity],
        time,
        color: getColor(checks[activity], date),
        visible: getVisibility(activity),
      };
    });
  };

  // if TerminatorFlight, hide the MAPS table
  if (flightDetail.TerminatorFlight !== 0) {
    return null;
  }

  // need to get model from flightDetail
  const activitiesList = getFlightActivities();

  return (
    <table className="table">
      <tbody>
        {activitiesList.map((row, index) => (
          <MapsTableRow
            key={index}
            color={row.color}
            visible={row.visible}
            activity={row.statement}
            time={row.time}
          />
        ))}
      </tbody>
    </table>
  );
};

export default MapsTable;
